module.exports = __webpack_public_path__ + "img/lo.c86fffbf.svg";